import { useContext } from 'react';
import { ApplicationContext } from '../context';

export function useApplication() {
  const { application, setApplication } = useContext(ApplicationContext);
  return [application, setApplication] as const;
}
